module.exports = __webpack_public_path__ + "img/jpm_icons1.591eb494.png";